import { Injectable } from '@angular/core';
/**
 * 
 * RenderingQueueServices rendering of the views for pages and thumbnails.
 * 
 */
export class LibService {

    renderingStates = {
        INITIAL: 0,
        RUNNING: 1,
        PAUSED: 2,
        FINISHED: 3
    };

    CLEANUP_TIMEOUT: number = 30000;

    pdfViewer: any = null;
    pdfThumbnailViewer: any = null;
    onIdle: any = null;

    highestPriorityPage: any = null;
    idleTimeout: any = null;
    printing: any = false;
    isThumbnailViewEnabled: any = false;
/**
 * @param {?} pdfViewer
 * @return {?}
 */
setViewer(pdfViewer) {
        this.pdfViewer = pdfViewer;
    }
/**
 * @param {?} pdfThumbnailViewer
 * @return {?}
 */
setThumbnailViewer(pdfThumbnailViewer) {
        this.pdfThumbnailViewer = pdfThumbnailViewer;
    }
/**
 * @param {?} view
 * @return {?}
 */
isHighestPriority(view: any) {
        return this.highestPriorityPage === view.renderingId;
    }
/**
 * @param {?} currentlyVisiblePages
 * @return {?}
 */
renderHighestPriority(currentlyVisiblePages) {
        if (this.idleTimeout) {
            clearTimeout(this.idleTimeout);
            this.idleTimeout = null;
        }

        // Pages have a higher priority than thumbnails, so check them first.
        if (this.pdfViewer.forceRendering(currentlyVisiblePages)) {
            return;
        }
        // No pages needed rendering so check thumbnails.
        if (this.pdfThumbnailViewer && this.isThumbnailViewEnabled) {
            if (this.pdfThumbnailViewer.forceRendering()) {
                return;
            }
        }

        if (this.printing) {
            // If printing is currently ongoing do not reschedule cleanup.
            return;
        }

        if (this.onIdle) {
            this.idleTimeout = setTimeout(this.onIdle.bind(this), this.CLEANUP_TIMEOUT);
        }
    }
/**
 * @param {?} visible
 * @param {?} views
 * @param {?} scrolledDown
 * @return {?}
 */
getHighestPriority(visible, views, scrolledDown) {
        // The state has changed figure out which page has the highest priority to
        // render next (if any).
        // Priority:
        // 1 visible pages
        // 2 if last scrolled down page after the visible pages
        // 2 if last scrolled up page before the visible pages
        let /** @type {?} */ visibleViews = visible.views;

        let /** @type {?} */ numVisible = visibleViews.length;
        if (numVisible === 0) {
            return false;
        }
        for (let /** @type {?} */ i = 0; i < numVisible; ++i) {
            let /** @type {?} */ view = visibleViews[i].view;
            if (!this.isViewFinished(view)) {
                return view;
            }
        }

        // All the visible views have rendered, try to render next/previous pages.
        if (scrolledDown) {
            let /** @type {?} */ nextPageIndex = visible.last.id;
            // ID's start at 1 so no need to add 1.
            if (views[nextPageIndex] && !this.isViewFinished(views[nextPageIndex])) {
                return views[nextPageIndex];
            }
        } else {
            let /** @type {?} */ previousPageIndex = visible.first.id - 2;
            if (views[previousPageIndex] && !this.isViewFinished(views[previousPageIndex])) {
                return views[previousPageIndex];
            }
        }
        // Everything that needs to be rendered has been.
        return null;
    }
/**
 * @param {?} view
 * @return {?}
 */
isViewFinished(view) {
        return view.renderingState === this.renderingStates.FINISHED;
    }
/**
 * Render a page or thumbnail view. This calls the appropriate function
 * based on the views state. If the view is already rendered it will return
 * false.
 * @param {?} view
 * @return {?}
 */
renderView(view: any) {
        let /** @type {?} */ state = view.renderingState;
        switch (state) {
            case this.renderingStates.FINISHED:
                return false;
            case this.renderingStates.PAUSED:
                this.highestPriorityPage = view.renderingId;
                view.resume();
                break;
            case this.renderingStates.RUNNING:
                this.highestPriorityPage = view.renderingId;
                break;
            case this.renderingStates.INITIAL:
                this.highestPriorityPage = view.renderingId;
                let /** @type {?} */ continueRendering = function () {
                    this.renderHighestPriority();
                }.bind(this);
                view.draw().then(continueRendering, continueRendering);
                break;
            default:
                break;
        }
        return true;
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function LibService_tsickle_Closure_declarations() {
/** @type {?} */
LibService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
LibService.ctorParameters;
/** @type {?} */
LibService.prototype.renderingStates;
/** @type {?} */
LibService.prototype.CLEANUP_TIMEOUT;
/** @type {?} */
LibService.prototype.pdfViewer;
/** @type {?} */
LibService.prototype.pdfThumbnailViewer;
/** @type {?} */
LibService.prototype.onIdle;
/** @type {?} */
LibService.prototype.highestPriorityPage;
/** @type {?} */
LibService.prototype.idleTimeout;
/** @type {?} */
LibService.prototype.printing;
/** @type {?} */
LibService.prototype.isThumbnailViewEnabled;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
